import React from "react"
import {formatTextTestIds} from "@next/utils"
import {ChargesAndIncentive} from "../../models/shoppingbag"
import {PromotionDiscount, PromotionText, PromotionWrapper} from "../MiniShoppingBagItems/component"

export type ChargesAndIncentiveItemProps = {
    incentive: ChargesAndIncentive
}

export const ChargesAndIncentiveItem = ({incentive}: ChargesAndIncentiveItemProps) => {
    return (
        <PromotionWrapper>
            <PromotionText>{incentive.OfferTypeDescription}</PromotionText>
            <PromotionDiscount data-testid={formatTextTestIds("header-mini-shopping-bag-additional-incentive")}>
                {incentive.AdditionalAmountFormatted}
            </PromotionDiscount>
        </PromotionWrapper>
    )
}

export default ChargesAndIncentiveItem
